import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DokumentKlienta } from '../../shared/models/dokument-klienta.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { FormatowanieDatService } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class DokumentyKlientaService {

    constructor(
        private http: HttpClient,
        private formatowanieDat: FormatowanieDatService,
    ) { }

    getDokumenty(zakresDat: ZakresDat): Observable<DokumentKlienta[]> {
        const params = new HttpParams()
            .set('dataOd', this.formatowanieDat.format(zakresDat.dataOd))
            .set('dataDo', this.formatowanieDat.format(zakresDat.dataDo));

        return this.http.get<DokumentKlienta[]>('/api/dokument-klienta', { params: params });
    }
}
